module.exports = __webpack_public_path__ + "img/vivofacil-logo.3876c9a3.png";